import { CoreTag } from '@featuring-corp/components';
import { flex } from '@styles/vanilla-extract/utils';
import React, { Fragment } from 'react';

import { BiMap } from '@utils/objects';

import { ReportProfileProps } from './ReportProfile';
import {
	bioClass,
	containerClass,
	platformIconClass,
	profileImgClass,
	rawDividerClass,
	rawKeyClass,
	rawValueClass,
	textContainerClass,
	textInnerContainer,
	userNameClass,
} from './style.css';
import LargeAvatar from '../large-avatar/LargeAvatar';
import SnsRounded from '../sns-rounded/SnsRounded';

const ReportProfileError = ({ rawData }: ReportProfileProps) => {
	const rawDataBiMap = new BiMap(rawData);
	return (
		<div className={containerClass}>
			<div className={profileImgClass}>
				<LargeAvatar colorType="gray" isBorder />
				<SnsRounded className={platformIconClass} />
			</div>

			<div className={textContainerClass}>
				<div className={textInnerContainer}>
					<CoreTag tagType="gray" text={'분석 불가'} />

					<h3 className={userNameClass}>{'데이터가 없거나 분석할 수 없습니다.'}</h3>

					<p className={bioClass}>-</p>
				</div>

				<div className={flex({ gap: 'spacing-400' })}>
					{rawDataBiMap.keys().map((key, idx) => (
						<Fragment key={idx}>
							{idx !== 0 && <div className={rawDividerClass} />}
							<div className={flex({ gap: 'spacing-100' })}>
								<span className={rawValueClass}>-</span>
								<span className={rawKeyClass}>{key}</span>
							</div>
						</Fragment>
					))}
				</div>
			</div>
		</div>
	);
};

export default ReportProfileError;
